<template>
  <b-row>
    <StepperCol :step="8" />
    <b-col cols="10" md="11" class="pb-4">
      <h5
        class="h3 font-weight-normal mb-4"
        :class="collapsed ? '' : 'text-muted'"
      >
        配管ホースを通す穴が近くにありますか？
      </h5>
      <b-collapse v-model="shrinking" class="d-md-none">
        <b-button
          variant="outline-warning"
          size="lg"
          class="btn-gd text-left position-relative py-2"
          block
          @click="shrinking = false"
        >
          <span class="h4 m-0">{{
            a0Selected
              ? "穴がある"
              : a1Selected
              ? "ない(木造•モルタル•ALC)"
              : "ない(鉄筋コンクリート)"
          }}</span>
          <div class="d-block text-muted">
            {{ a0Selected ? "¥0-" : a1Selected ? "¥3,300~" : "¥22,000~" }}
          </div>
          <div class="accessory-shrinking">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 12 12"
            >
              <polyline
                fill="none"
                stroke="#FD9000"
                stroke-width="2"
                points="0,6 6,11 12,6"
              />
            </svg>
          </div>
        </b-button>
      </b-collapse>
      <b-collapse v-model="isCollapsed">
        <b-form-row>
          <b-col cols="12" md="4" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-205px"
              :class="a0Selected ? 'selected' : ''"
              @click="buttonClicked(0)"
            >
              <h6 class="h4 px-3 pt-3">配管ホースを通す穴がある</h6>
              <div class="pl-2">
                <b-img
                  fluid
                  :src="require('@/assets/images/q-6-1@2x.png')"
                ></b-img>
                <dl
                  class="text-muted mb-0 position-absolute"
                  style="bottom: 20px; left: 25px"
                >
                  <dt>追加工事</dt>
                  <dd class="font-weight-bold h5 mb-0">
                    ¥<span class="h3 ml-1">0-</span>
                  </dd>
                </dl>
              </div>
            </b-button>
          </b-col>
          <b-col cols="12" md="4" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-205px"
              :class="a1Selected ? 'selected' : ''"
              @click="buttonClicked(1)"
            >
              <h6 class="h4 px-3">配管ホースを通す穴がない</h6>
              <p class="pl-3 h5">
                <span class="text-muted">壁の材質:</span
                ><span class="text-danger">木造•モルタル•ALC</span>
              </p>
              <div class="pl-2">
                <b-img
                  fluid
                  :src="require('@/assets/images/q-6-2@2x.png')"
                ></b-img>
                <dl
                  class="text-muted mb-0 position-absolute"
                  style="bottom: 20px; left: 25px"
                >
                  <dt>追加工事</dt>
                  <dd class="font-weight-bold h5 mb-0">
                    ¥<span class="h3 ml-1">3,300~</span>
                  </dd>
                </dl>
              </div>
            </b-button>
          </b-col>
          <b-col cols="12" md="4" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-205px"
              :class="a2Selected ? 'selected' : ''"
              @click="buttonClicked(2)"
            >
              <h6 class="h4 px-3">配管ホースを通す穴がない</h6>
              <p class="pl-3 h5">
                <span class="text-muted">壁の材質:</span
                ><span class="text-danger">鉄筋コンクリート</span>
              </p>
              <div class="pl-2">
                <b-img
                  fluid
                  :src="require('@/assets/images/q-6-2@2x.png')"
                ></b-img>
                <dl
                  class="text-muted mb-0 position-absolute"
                  style="bottom: 20px; left: 25px"
                >
                  <dt>追加工事</dt>
                  <dd class="font-weight-bold h5 mb-0">
                    ¥<span class="h3 ml-1">22,000~</span>
                  </dd>
                </dl>
              </div>
            </b-button>
          </b-col>
        </b-form-row>
      </b-collapse>
    </b-col>
  </b-row>
</template>

<script>
import StepperCol from "../StepperCol";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    StepperCol,
  },
  data() {
    return {
      collapsed: false,
      shrinking: false,
      a0Selected: false,
      a1Selected: false,
      a2Selected: false,
    };
  },
  watch: {
    currentStep(val, old) { // eslint-disable-line
    },
    maxStep(val, old) { // eslint-disable-line
      if (val >= 8) {
        this.collapsed = true;
      }
    },
  },
  computed: {
    ...mapState({
      currentStep() {
        return this.$store.getters.currentStep;
      },
      maxStep() {
        return this.$store.getters.maxStep;
      },
    }),
    isCollapsed: {
      get() {
        if (this.shrinking) {
          if (window.innerWidth < 576) {
            return false;
          } else {
            return true;
          }
        } else {
          return this.collapsed;
        }
      },
      set(value) { // eslint-disable-line
      },
    },
  },
  methods: {
    reset() {
      this.shrinking = false;
      this.collapsed = false;
      this.a0Selected = false;
      this.a1Selected = false;
      this.a2Selected = false;
    },
    ...mapActions({
      doUpdateStep: "doUpdateStep",
      doSaveAnswer: "doSaveAnswer",
    }),
    buttonClicked(value) {
      if (value == 0) {
        this.a0Selected = true;
        this.a1Selected = false;
        this.a2Selected = false;
      } else if (value == 1) {
        this.a0Selected = false;
        this.a1Selected = true;
        this.a2Selected = false;
      } else {
        this.a0Selected = false;
        this.a1Selected = false;
        this.a2Selected = true;
      }
      this.doSaveAnswer({ keyword: 'has_hole', answer: value });
      if (value == 0) {
        this.doUpdateStep(9);
      } else {
        // step8を飛ばす
        this.doSaveAnswer({ keyword: 'hole_type', answer: 0 });
        this.doUpdateStep(10);
      }
      this.shrinking = true;
    },
  },
};
</script>